import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelopeOpenText,
  faExclamationTriangle,
  faTimes,
  faWifi,
} from '@fortawesome/free-solid-svg-icons';
import css from 'styled-jsx/css';

import {
  ASSET_TABS,
  COMMAND_HISTORY,
  DM1_FAULTS,
  SUBSCRIPTIONS,
  VALIDATION_ERRORS,
} from '../../Constants/Asset';

const { className: heightClass, styles: heightStyles } = css.resolve`
  div {
    height: calc(100% - 60px);
  }
`;

export default memo(MobileTabLinksModal);
function MobileTabLinksModal({
  assetFormat,
  handleTabChange,
  isOpen,
  tab,
  toggleModal,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleModal}
      size="sm"
      backdropClassName={heightClass}
      modalClassName={heightClass}
      className="h-100 my-0 pb-2 d-flex flex-column justify-content-end"
    >
      <ModalBody>
        {[
          [DM1_FAULTS, faExclamationTriangle, 'DM1 Faults'],
          [COMMAND_HISTORY, faWifi, 'Command History'],
          [SUBSCRIPTIONS, faEnvelopeOpenText, 'Subscriptions'],
          [VALIDATION_ERRORS, faTimes, 'Errors'],
        ]
          .filter(([tabName]) => {
            if (assetFormat !== 'json' && tabName === VALIDATION_ERRORS) {
              return false;
            }
            return true;
          })
          .map(([tabName, icon, displayText]) => (
            <button
              key={tabName}
              className={`btn btn-link w-100 d-flex align-items-center ${
                tab === tabName ? 'text-brand-primary' : 'text-icon-link-gray'
              }`}
              onClick={() => handleTabChange(tabName)}
            >
              <div className="w-25 text-center">
                <FontAwesomeIcon icon={icon} size="lg" />
              </div>
              <span>{displayText}</span>
            </button>
          ))}
      </ModalBody>
      {heightStyles}
    </Modal>
  );
}

MobileTabLinksModal.propTypes = {
  assetFormat: PropTypes.oneOf(['json', 'protobuf']),
  handleTabChange: PropTypes.func,
  isOpen: PropTypes.bool,
  tab: PropTypes.oneOf(ASSET_TABS),
  toggleModal: PropTypes.func,
};
